module.exports = __webpack_public_path__ + "static/media/cwu_off.73e4e3a9.svg";